export default __webpack_public_path__ + "static/media/02_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A7638.8778093a.jpg";